import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Mail` — envelope outline with flap line.
 *
 * Canonical use: communication glyphs in messaging, email, phone, notifications.
 * Aria label:    Mail
 * Family:        communication
 * Related:       mail-open, mail-plus, mail-check, mail-x, send, inbox
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Mail.
 *
 */
export const Mail = forwardRef(function Mail(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M3 6 h18 v12 a2 2 0 0 1 -2 2 H5 a2 2 0 0 1 -2 -2 z" }), _jsx("path", { d: "M3 6 l9 7 9 -7" })] }));
});
//# sourceMappingURL=mail.js.map